import { registryApi } from '../clients/AxiosClients'
// import axios from "axios"

export const getUsuarios = () => {
	return registryApi.get('v1/Usuario/GetUsuarios')
}

export const updateUsuario = (usuario) => {
	return registryApi.put('v1/Usuario', usuario)
}

export const deleteUsuariosByIdList = (idUsuarioList) => {
	return registryApi.delete('v1/Usuario/DeleteByIdList', { data: idUsuarioList })
}

export const createUsuario = (usuario) => {
	return registryApi.post('v1/Usuario', usuario)
}

export const createUsuarioComFoto = (usuario) => {
	return registryApi.post('v1/Usuario/CreateUsuarioComFoto', usuario)
}

export const updateUsuarioComFoto = (usuario) => {
	return registryApi.put('v1/Usuario/UpdateUsuarioComFoto', usuario)
}
